import type { ComponentProps } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

export type TooltipProviderProps = ComponentProps<typeof TooltipPrimitive.Provider>;

export const TooltipProvider = ({ delayDuration = 0, ...props }: TooltipProviderProps) => (
  <TooltipPrimitive.Provider data-slot="tooltip-provider" delayDuration={delayDuration} {...props} />
);
